import { render } from "./FileManagement.vue?vue&type=template&id=6b4ee73e"
import script from "./FileManagement.vue?vue&type=script&lang=js"
export * from "./FileManagement.vue?vue&type=script&lang=js"

import "./FileManagement.vue?vue&type=style&index=0&id=6b4ee73e&lang=scss"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__